import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertsService } from '../../services/alerts.service';
import { CommonService } from '../../services/common.service';
import { CommunicationService } from '../../services/communication.service';
import { LoaderService } from '../../services/loader.service';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { BaseService } from '../../shared/services/base.service';
import { RolePermissionService } from '../../shared/services/role-permission.service';
import { DialogModalSize } from "src/modules/base/components/dialog/dialog-ref";
import { PopupFormComponent } from "src/modules/base/components/popupform/popupform.component";
import { DialogService } from "src/modules/base/components/dialog/dialog.service";


@Component({
    selector: 'kx-cart',
    templateUrl: './cart.component.html',
    styleUrls: ['./cart.component.scss'],
    standalone: false
})
export class CartComponent implements OnInit {
  showItems: boolean = true;
  data: any;
  config: any = {
    "submitButton": false,
    "cancelButton": false,
    "filterForm": false,
    "clearOnSave": false,
    "delegateSave": true,
    "cancelRoute": ''
  };
  @Input() orderField: any
  @Input() patientField: any;
  @Output() bookAppointment = new EventEmitter<any>();
  @Output() removeItem = new EventEmitter<any>();
  @Output() document = new EventEmitter<any>();
  @Output() tAndC = new EventEmitter<any>();
  @Output() patientDetail = new EventEmitter<any>();
  total: any;
  resourceDef: any;
  @Output() appointment = new EventEmitter<any>();
  @Output() getpatientdetailVisitHistoryData = new EventEmitter<any>();
  remarks: any;
  showRemarks: boolean = true;
  @Input() name: any;
  openItems: boolean = true;
  flag: boolean = true;
  consultationDecorator: any;
  priorityApi: boolean = true;
  discount: any = 0;
  tariff: any = 0;
  emergency_charges: any = 0;
  reason_name: any; patientName: any;
  newresult: any;
  phc_reason_mandatory_config: boolean = false;
  isPinRequired: boolean = false;
  doctor_appointment_reason_mandatory_config: boolean = false;
  formObject: any;
  treatingDoctorConfig: any;
  treatingDoctorConfsig: any;
  currentRole: any;

  constructor(
    public coomunication: CommunicationService,
    private baseService: BaseService,
    public rolePermissionService: RolePermissionService,
    private alert: AlertsService,
    public loader: LoaderService,
    private Aroute: ActivatedRoute,
    private auth: AuthenticationService,
    private dialogService: DialogService,
    public commonService?: CommonService
  ) { }

  ngOnInit() {
    this.currentRole = JSON.parse(localStorage.CURRENT_ROLE) // get current role
    this.coomunication.getcartData$.subscribe((res: any) => {
      console.log("response is :: ", res);
      this.showItems = true;
      this.openItems = true;
      this.data = res;
      if (this.auth.getUserType() != "patient") {
        this.treatingDocConfig()
      }
      this.getPinValidation() // check pin validation  res.registrationservice.length > 0
      this.showRemarks = true;
      this.total = res.services[0].final_payable;
      this.discount = res.services[0].discount;
      this.tariff = res.services[0].total_amount;
      this.emergency_charges = res.services[0].emergency_charges
      this.baseService.getResourceDef((this.auth.getUserType() == "patient") ? 'patient_appointment_popup_form' : (this.data.services[0].serviceType_code == "phc" ? 'package_remarks' : 'doctor_appointment_popup_form'), (data) => {
        this.resourceDef = data;
        if (data.config != undefined && data.config.decorator != undefined) {
          //if decorator  not initialzed or its not same as previous decorator then initialze it
          if (!this.consultationDecorator || (this.consultationDecorator && this.consultationDecorator.className != undefined && this.consultationDecorator.className != data.config.decorator)) {
            this.consultationDecorator = this.baseService.initDecorator(data.config.decorator, this.Aroute);
          }
        }
      })
    })
    this.coomunication.emitBtnArgs.subscribe((res: any) => {
      this.flag = res;
    })
    this.coomunication.emitclearCart$.subscribe((res: any) => {
      this.showItems = false;
      this.openItems = false;
    })
  }


  checkdataType(data) {
    return Array.isArray(data.patientdetails)
  }

  questionValueChanged(data) {
    let obj = {
      appointment_reason: data.form.value.appointment_reason,
      remarks: data.form.value.remarks
    }
    this.appointment.emit(obj)
  }

  hasItems() {
    return this.showItems = !this.showItems
  }

  hidecheck() {
    return this.openItems = !this.openItems
  }

  bookOrder(cost: any) {
    //  this.checkReasonconfig()
    if (!this.checkReasonconfig()) {
      this.loader.hideSpinner()
      return true;
    }
    if (this.data.services.length == 0)
      return
    if (document.getElementsByClassName("payer_detail")[0] != undefined)
      if (document.getElementsByClassName("multiselect_payer")[0].children[0].children[0].children[0].children[1]['innerText'] == 'Search Payer' && this.data.services[0].serviceType_code == "op_consultation") {
        this.alert.error("Please select valid Payer Name");
        return
      } else if (this.flag == false) {
        this.alert.error("Please select valid Payer Name");
        return
      }
    if (this.isPinRequired && this.isPinRequired == true && this.currentRole.role.includes("Facility Admin")) {
      this.loader.hideSpinner();// check conditions
      this.checkingPin(cost);
    } else {
      this.bookAppointment.emit({ price: this.total, discount: this.discount, tarrif_amount: this.tariff, scheme_discount_applicable: this.data.scheme_discount_applicable, patient_amount: this.data.patient_amount, payer_amount: this.data.payer_amount, net_amount: this.data.services[0].net_amount })
    }
  }




  treatingDocConfig() {
    this.baseService.get('GET_CONFIG', 'module_code:facility-management,config_code:facility_mgnt_0011,facility_id:' + this.data.facility_id, 'facility_config_mapping', 'facility-management').subscribe(
      result => {
        if (result.errCode == 0 && result.resource.length > 0) {
          this.newresult = result.resource[0].multivalue;
          this.newresult.find(e => {
            if (e.id == 'appointment' && this.data.services[0].serviceType_code == "op_consultation") {
              this.doctor_appointment_reason_mandatory_config = true;
            }
            if (e.id == 'phc_reason' && this.data.services[0].serviceType_code == "phc") {
              this.phc_reason_mandatory_config = true;
            }
          });
          if (this.doctor_appointment_reason_mandatory_config && this.data.services[0].serviceType_code == "op_consultation") {
            setTimeout(() => {
              if (this?.consultationDecorator?.formService?.form?.controls?.appointment_reason?.question_component) {
                this.consultationDecorator.formService.form.controls.appointment_reason.question_component.question.required = this.phc_reason_mandatory_config;

              }
            }, 100);
          }
          if (this.phc_reason_mandatory_config && this.data.services[0].serviceType_code == "phc") {
            setTimeout(() => {
              if (this?.consultationDecorator?.formService?.form?.controls?.appointment_reason?.question_component) {
                this.consultationDecorator.formService.form.controls.appointment_reason.question_component.question.required = this.phc_reason_mandatory_config;
              }
            }, 100);
          }
        }
      });
  }

  checkDiscCondition() {
    return (this.auth.appService.getUniversalConfig('multi_care_type') && this.auth.appService.getDynamicFunctions("getCurrentCareType") == 'general' && this.auth.getUserType() == "patient");
  }

  checkReasonconfig(): any {
    if (this.doctor_appointment_reason_mandatory_config && this.consultationDecorator.formService.form.controls.appointment_reason.value == "") {
      this.consultationDecorator.formService.form.controls.appointment_reason.question_component.question.required = true;
      this.alert.error("Reason is mandatory as per configuration setup")
      return false
    } else if (this.phc_reason_mandatory_config && this.consultationDecorator.formService.form.controls.appointment_reason.value == "") {
      this.consultationDecorator.formService.form.controls.appointment_reason.question_component.question.required = true;
      this.alert.error("Reason is mandatory as per configuration setup")
      return false
    }
    return true
  }

  payerDocument(event: any, payerId: any, payerName: any) {
    this.document.emit({ data: event, selectedPayer: payerId, selectedPayerName: payerName })
  }

  payerTerms(event: any, payerId: any, payerName: any) {
    this.tAndC.emit({ data: event, selectedPayer: payerId, selectedPayerName: payerName })
  }

  removeAppointment(index: any) {
    this.hasItems()
    this.total = null;
    this.showRemarks = false;
    this.openItems = false;
    this.removeItem.emit(index);
  }

  getpatientdetail(_data: any) {
    this.patientDetail.emit(_data);
  }

  getpatientdetailVisitHistory(_data: any) {
    this.getpatientdetailVisitHistoryData.emit(_data)
  }

  chckPermission(action, application, resource) {
    return this.rolePermissionService.checkAccessPermission(action, application, resource)
  }

  checkItems() {
    if (this.showItems) {
      return { 'height': 'auto' }
    } else if (this.openItems) {
      return { 'height': 'auto' }
    } else {
      return { 'display': 'none' }
    }
  }

  _getPatientDetailUHid() {
    return this.patientField.map((x, index) => {
      return this.checkName(x) + this.checkindex(index, x)
    }).join("")
  }

  checkindex(i, x) {
    if (this.patientField.length != i + 1 && this.data.patientdetails[x.name] && x.name != "patient_name") {
      return " | "
    } else {
      return ""
    }
  }

  getName(name) {
    this.patientName = name;
  }

  checkName(x) {
    if (x.name == "patient_name") {
      return ""
    } else {
      return this.data.patientdetails[x.name] == undefined ? "" : this.data.patientdetails[x.name]
    }
  }

  _kxgetPatientDetailUHid(data) {
    return this.patientField.map((x, index) => {
      return this.kxcheckName(x, data) + this.kxcheckindex(index, x, data)
    }).join("")
  }

  kxcheckindex(i, x, data) {
    if (this.patientField.length != i + 1 && data[x.name] && x.name != "patient_name") {
      return " | "
    } else {
      return ""
    }
  }

  kxcheckName(x, data) {
    if (x.name == "patient_name") {
      return ""
    } else {
      return data[x.name] == undefined ? "" : data[x.name]
    }
  }

  getClass(item, field?) {
    let class_: string = "";
    if (field != undefined && field.name != undefined && (field.name == 'priority')) {
      if (this.priorityApi) {
        this.commonService.getPriorityColor();
        this.priorityApi = false
      }
      let priorityData = this.commonService.servicePriorityList != undefined ? this.commonService.servicePriorityList.find(x => (x.serviceType_code == item.serviceType_code) && (x.service_priority_id == (item.priority_code || item.priorityCode || item.priority || item.priority_id || item.servicePriorityCode))) : '';
      return class_ = (priorityData && priorityData.color_Id != undefined) ? priorityData.color_Id : '';
    }
  }

  getPinValidation() {  //Gets config for pin/password required or not
    this.baseService.get('GET_CONFIG', 'module_code:emr,config_code:pin_required,facility_id:' + this.data.facility_id, 'facility_config_mapping', 'facility-management').subscribe(data => {
      if (data.errCode == 0 && data.resource.length > 0 && data.resource[0].multivalue && data.resource[0].multivalue.length > 0) {
        data.resource[0].multivalue.find(element => {
          if (element.id == "appointment") {
            this.isPinRequired = true;
          }
        })
      } else {
        this.isPinRequired = false;
      }
    });
  } // check Config for pin Validation  end 

  checkingPin(cost) { //validate password or pin
    let popObj = {
      "data": [], "action": "ADD", "getdata": true, "layout_type": "simple",
      "application": "emr", "title": 'Validate PIN', "size": DialogModalSize.Sm,
      "resource": 'op_validate_pin',
      "customButton": {
        "Add": [
          {
            "label": "button.confirm",
            "icon": "fa fa-check"
          }
        ]
      }
    }
    this.dialogService.open(PopupFormComponent, popObj).afterClosed.subscribe(response => {
      if (response && response.result && response.result.pin) {
        this.loader.showSpinner();
        let inputPin = response.result.pin
        this.baseService.action({ pin: inputPin }, "authenticate_pin", "account-management", "manage_user_pin").subscribe(res => {
          if (res.errCode == 0) {
            if (res && res.resource && res.resource.length > 0) {
              let isAuth = res.resource[0].is_authorised;
              if (isAuth) {
                this.bookAppointment.emit({ price: cost, discount: this.discount, tarrif_amount: this.tariff, scheme_discount_applicable: this.data.scheme_discount_applicable, patient_amount: this.data.patient_amount, payer_amount: this.data.payer_amount, net_amount: this.data.services[0].net_amount })
              } else {
                this.loader.hideSpinner();
                this.alert.error("Incorrect PIN");
              }
              console.log("event to be passed in complete order");
            }
          }
          else if (res.errCode == -1) {
            //    this.container.isPinValidated = false;
            this.alert.error("Please generate your Pin by clicking on profile icon at the top right corner")
          }
          this.loader.hideSpinner();
        })
      } else {
        //TODO Popup closed without pin
      }
    });
  }


}